import { z } from 'zod';

const numberList = z
  .object({
    value: z.union([z.number(), z.array(z.number())]).optional(),
    operator: z.enum(['eq', 'in', 'null', 'notnull']),
  })
  .optional();

const stringFilter = z
  .object({
    value: z.string().optional(),
    operator: z.enum(['eq', 'containsIgnoreCase']),
  })
  .optional();

export const descendantItemFilterSearchSchema = z.object({
  'descendant.itemTypeId': numberList,
  'descendant.estimationId': numberList,
  'descendant.statusId': numberList,
  'descendant.teamId': numberList,
  'descendant.name': stringFilter,
  'descendant.externalKey': stringFilter,
});

export const isDescendantPicklistFilterKey = (
  key: string,
): key is keyof z.infer<typeof descendantItemFilterSearchSchema> => {
  return key in descendantItemFilterSearchSchema.shape;
};
